
import Vue from 'vue'
import { yandexMap as YandexMap } from 'vue-yandex-maps'
import CartPoint from '../cart-point/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  components: {
    YandexMap,
    CartPoint
  },
  mixins: [staticBlockMixin],
  methods: {
    closeMarkerPopup () {
      this.selectedPointId = null
    }
  }
})
